var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-button',_vm._b({attrs:{"icon":"edit"},on:{"click":function($event){return _vm.$emit('click')}}},'icon-button',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }